const commonRo = {
    "restaurant": "Restaurant",
    "restaurant_not_found": "Restaurantul nu este disponibil",
    "table_not_available": "Nu se pot plasa comenzi la această masă",
    "note": "Nota",
    "order": "Comanda",
    "internal_error": "Cererea nu a reușit. Serverul a răspuns cu următoarea eroare:",
    "no_results": "Niciun rezultat",
    "cancel": "Anula",
    "save": "Salva",
    "back": "Spate",
    "search": "Căutare",
    "search_for_file_names": "Căutați nume de fișiere",
    "delete": "Şterge",
    "search_by_restaurant": "Căutare după restaurant",
    "available": "Disponibil",
    "unavailable": "Indisponibil",
    "name": "Nume",
    "status": "Stare",
    "description": "Descriere",
    "price": "Preţ",
    "add": "Adăuga",
    "phone": "Telefon",
    "internal_server_error": "Internal Server Error",
    "remove_all": "Ștergeți tot",
    "settings": "Setări",
    "restaurant_name": "Numele restaurantului",
    "reservation_link": "Link de rezervare",
    "reservation_link_tooltip": "Sunt permise doar linkurile către sistemul de rezervări Reservoirs",
    "add_user": "Adăugați utilizator",
    "add_user_title": "Acordați acces la restaurant",
    "restaurant_users": "Utilizatori cu acces la restaurant",
    "restaurant_description_hu": "Descrierea restaurantului (în maghiară)",
    "restaurant_description_en": "Descrierea restaurantului (în engleză)",
    "changes_saved": "Modificările au fost salvate cu succes",
    "user_added_to_restaurant": "Utilizatorului i s-a permis accesul la restaurant",
    "user_add_to_restaurant_tip": "Utilizatorului cu adresa de e-mail furnizată i se va acorda acces la restaurantul selectat. Dacă utilizatorul nu are încă un cont, va primi automat acces după înregistrare.",
    "sign_up_here": "Îți poți crea un cont aici",
    "role_already_exists": "Utilizatorul cu această adresă de e-mail are deja acces la restaurant",
    "error": "Eroare",
    "header_image": "Imaginea antetului",
    "upload_image": "Încărcați imaginea",
    "image_not_set": "Imaginea nu este setată",
    "validation": {
        "required": "Acest câmp este obligatoriu",
        "optional": "Acest câmp este opțional"
    },
    "hungary": "Ungaria",
    "date": "Data",
    "close": "Aproape",
    "continue": "Continua",
    "select_image": "Selectați imaginea",
    "grant": "Acorda",
    "restaurant_settings": "Setările restaurantului",
    "create_restaurant": "Creați un restaurant",
    "restaurant_created": "Restaurantul a fost creat cu succes",
    "restaurant_created_text": "Restaurantul dvs. a fost creat cu succes. Acum puteți adăuga elemente din meniu și gestiona setările restaurantului.",
    "continue_to_menu": "Continuați la editarea meniului",
    "languages": {
        "hu": "Maghiară",
        "en": "Engleză",
        "de": "german",
        "fr": "franceză",
        "sk": "Slovacă",
        "cz": "ceh",
        "pl": "Lustrui",
        "si": "Slovenă",
        "hr": "croat",
        "ro": "Română"
    },
    "no_file_selected": "Niciun fișier selectat",
    "max_file_size": "Dimensiunea maximă a fișierului:",
    "language": "Limbă",
    "google_analytics": "Google Analytics",
    "facebook_pixel": "Pixelul Facebook",
    "analytic_integration_premium_feature": "Integrarea analizelor face parte din planul PRO",
    "refresh": "Reîmprospăta",
    "address": "Adresa",
    "city": "Oraş",
    "postal_code": "Cod poștal",
    "timezone": "Fus orar",
    "country": "Ţară",
    "currency": "Valută",
    "currency_tooltip": "Acest lucru este necesar doar pentru setările profilului, sistemul nostru nu va efectua tranzacții financiare în numele dumneavoastră.",
    "or": "sau"
};

export default commonRo;
